<script>
  import Section from './Section.svelte';
  import Modal from './Modal.svelte';
  import CaptureService from '../services/capture.service';

  const noDevices = { name: 'No devices' };
  let error = false;
  let pleaseWait = false;
  let modal = {title: '', message: ''};
  let properties = CaptureService.getProperties().map(p => {
    const result = [];
    const get = {
      name: 'get ' + p.name,
      id: p.id,
      type: p.get,
      get: true
    };
    const set = {
      name: 'set ' + p.name,
      id: p.id,
      type: p.set,
      get: false
    };
    if(get.type.name.indexOf('kNotApplicable')=== -1){
      result.push(get);
    }
    if(set.type.name.indexOf('kNotApplicable')=== -1){
      result.push(set);
    }
    return result;
  }).flat(1);
  
  properties.sort((a, b) => ignoreGetSet(a.name).localeCompare(ignoreGetSet(b.name)));

  let devices = CaptureService.getAllDevices(true).filter( d => d.handle);
  let deviceSelected = devices.length > 0 ? devices[0] : noDevices;
  let byteValue;
  let ulongValue;
  let stringValue;
  let arrayValue;
  let deviceResponseSelected;
  let propertySelected;
  let propertyType = { type: { name: 'None' }};
  let devicePropertyResponses = deviceSelected.deviceHandle? CaptureService.getDevicePropertyResponses(deviceSelected.deviceHandle): [];
  console.log('properties ', properties);
  console.log(devices);
  CaptureService.setNotification((handle, devicesListChanged) => {
    console.log(`Receive something from Capture handle: ${handle} devices list changed: ${devicesListChanged}`);
    if(devicesListChanged){
      devices = CaptureService.getDevices();
    }
    else{
      devicePropertyResponses = CaptureService.getDevicePropertyResponses(handle) || [];
      devicePropertyResponses = devicePropertyResponses.map(JSON.stringify);
      console.log('device property responses: ', devicePropertyResponses);
    }
  });

  const onDeviceSelectedChange = () => {
    console.log('device selected changed: ', deviceSelected);
  };

  const onDeviceResponseSelectedChange = () => {
    console.log('device response selected changed: ', deviceResponseSelected);
  };

  const onPropertySelectedChange = () => {
    console.log('property selected changed: ', propertySelected);
    propertyType = {...propertySelected};
  };

  const onSendPropertyCapture = async () => {
    const newProperty = { ...propertySelected };
    newProperty.byteValue = byteValue || 0;
    newProperty.ulongValue = ulongValue || 0;
    newProperty.stringValue = stringValue || '';
    newProperty.arrayValue = arrayValue || [];
    try{
      await CaptureService.sendProperty(deviceSelected.handle, newProperty.get, newProperty);
    }
    catch(err) {
      error = true;
      modal.title = 'Error Send Property';
      if(err.error){
        modal.message = `${err.error.code} ${err.error.message}`;
      }
      else {
        modal.message = err.message;
      }
    }
  };

  function ignoreGetSet(getSetProperty) {
    const property = getSetProperty.split(' ');
    return property[1];
  }
</script>

<h2>Capture Property</h2>
<Section name="Property">
  <form on:submit|preventDefault={onSendPropertyCapture}>
    <div class="column">
      <label>Devices present
        <select bind:value={deviceSelected} on:change={onDeviceSelectedChange}>
          {#each devices as device}
          <option value={device}>{device.name}</option>
          {:else}
          <option value={noDevices} selected="true">{noDevices.name}</option>
          {/each}
        </select>
      </label>
      <label>Property ID
        <select bind:value={propertySelected} on:change={onPropertySelectedChange}>
          {#each properties as property}
          <option value={property}>{property.name}</option>
          {:else}
          <option value="No devices" selected="true">No devices</option>
          {/each}
        </select>
      </label>
      {#if propertyType.type.name === 'kByte'}
      <label>Byte (prefix with 0x for hex value)
        <input bind:value={byteValue} disabled={!deviceSelected}>
      </label>
      {:else if propertyType.type.name === 'kUlong'}
      <label>Long (prefix with 0x for hex value)
        <input bind:value={ulongValue} disabled={!deviceSelected}>
      </label>
      {:else if propertyType.type.name === 'kString'}
      <label>String
        <input bind:value={stringValue} disabled={!deviceSelected}>
      </label>
      {:else if propertyType.type.name === 'kArray'}
      <label>Array (hex and comma separated. e.g. 0x00, 0x02, 0x81)
        <input bind:value={arrayValue} disabled={!deviceSelected}>
      </label>
      {/if}
    </div>
    <div class="column">
      <div class="bottom-right">
        <button type="submit">Send</button>
      </div>
    </div>
  </form>
</Section>
<Section name="Property Responses">
  <form>
    <div class="column">
      <label>Devices present
        <select bind:value={deviceResponseSelected} on:change={onDeviceResponseSelectedChange}>
          {#each devices as device}
          <option value={device}>{device.name}</option>
          {:else}
          <option value="No devices" selected="true">No devices</option>
          {/each}
        </select>
      </label>
    </div>
    <div class="column">
    </div>
  </form>
  <label>Responses
    <textarea cols="30" rows="10" value={devicePropertyResponses.join('\n')}></textarea>
  </label>
</Section>
{#if error || pleaseWait}
<Modal>
  <div class="modal-container">
    <div class="modal-title">
      <h2>{modal.title}</h2>
    </div>
    <div class="center">
      <h3>{@html modal.message}</h3>
      {#if error}
      <button on:click={()=>{error = false;}}>OK</button>
      {/if}
    </div>
  </div>
</Modal>
{/if}
<style>
  h2 {
    margin: 10px;
  }

  label {
    display: flex;
    gap: 5px;
    margin: 5px;
    flex-direction: column;
    font-size: 1.2em;
  }
  
  input {
    padding: 5px;
    border: none;
    border-radius: 5px;
    font-size: 1.2em;
  }
  
  button {
    padding: 10px 30px;
    font-size: 1.2em;
    border-radius: 5px;
  }

  select {
    font-size: 1.2em;
    padding: 5px;
    border-radius: 5px;
  }

  form {
    display: flex;
    gap: 10px;
  }

  textarea {
    width: 100%;
    font-size: 1.2em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
    border-radius: 5px;
    resize: vertical;
  }

  .column {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 5px;
  }

  .bottom-right {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
  }

  .bottom-right button {
    align-self: flex-end;
  }

  .modal-container {
    text-align: center;
    background-color: #D77C33;
  }

  .center {
    padding: 10px;
    background-color: #DDDDBE;
    border-radius: 5px;
  }

  .center button {
    margin-top: 20px;
  }
	@media  screen and (max-width: 812px) {
		form {
			flex-direction: column;
		}
    .bottom-right {
      position:relative;
    }
    .bottom-right button{
      position:relative;
    }
	}
</style>
